import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const defaultValues = {
  description: '',
};

const resolver = yupResolver(
  yup.object().shape({
    description: yup.string().test('len', 'Máx. 150 caracteres', (val) => !val || val.length <= 150),
  })
);

export { defaultValues, resolver };
